import { get } from 'lodash';
import {
	SUBMIT_GET_EXCHANGE_RATES_SUCCESS,
	SUBMIT_GET_EXCHANGE_RATES_FAILURE,
	RESET_FX_RATES,
	SUBMIT_GET_EXCHANGE_RATES_REQUEST,
} from './actions';

const initialState = {
	error: undefined,
	ratesApiInProgress: 0,
	fxRates: {},
};

const rates = (state = initialState, action) => {
	switch (action.type) {
		case SUBMIT_GET_EXCHANGE_RATES_SUCCESS: {
			const fxRates = {
				...state.fxRates,
				[get(action, 'meta.paymentId')]: action.payload,
			};
			return {
				...state,
				fxRates,
				error: undefined,
				ratesApiInProgress: state.ratesApiInProgress - 1,
			};
		}
		case SUBMIT_GET_EXCHANGE_RATES_FAILURE: {
			return {
				...state,
				error: action.payload,
				ratesApiInProgress: state.ratesApiInProgress - 1,
			};
		}
		case RESET_FX_RATES: {
			return { ...state, ...initialState };
		}
		case SUBMIT_GET_EXCHANGE_RATES_REQUEST: {
			return {
				...state,
				...initialState,
				ratesApiInProgress: state.ratesApiInProgress + 1,
			};
		}
		default:
			return state;
	}
};

export default rates;
